import { Injectable } from '@angular/core';
import { FlamingoError } from '@flamingo/service/flamingo-error.handler';
import { FlamingoMessageService } from '@flamingo/service/flamingo-message.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { catchError, filter, switchMap, tap } from 'rxjs/operators';
import { Invoice } from '../../../../../../../core/model/invoice.model';
import { CompanyStatus, SellerAccountView } from '../../../../../../../core/model/seller-account-view.model';
import { MainService } from '../../../../../main.service';
import { SellerService } from '../../../seller.service';
import { ErrorPublishDialogComponent } from '../component/error-publish-dialog/error-publish-dialog.component';
import { PublishTosDialogComponent } from '../component/publish-tos-dialog/publish-tos-dialog.component';
import { InvoiceService } from '../invoice.service';

@Injectable({
  providedIn: 'root',
})
export class PublishInvoiceService {

  today = moment();


  constructor(
    private _invoiceService: InvoiceService,
    private _mainService: MainService,
    private _messageService: FlamingoMessageService,
    private _translateService: TranslateService,
    private _userSellerService: SellerService,
  ) {
  }

  handlePublish(res: any): void {
    if (res.refresh) {
      this._invoiceService.refreshInvoice$.next();
    }

    if (res.publish) {
      this.publishInvoice(res.publish);
    }
  }

  publishInvoice(uuid: string): void {
    if (!this.checkUserProfile()) {
      this._messageService
        .showMessageDialog(
          this._translateService.instant('INVOICE.ERROR_DIALOG.TITLE'),
          this._translateService.instant('INVOICE.ERROR_DIALOG.MESSAGE_PROFILE'),
          'Ok',
          600,
        )
        .subscribe();
    } else {
      // controllo di essere utente attivo / selling / not selling / to review
      if (![CompanyStatus.activated, CompanyStatus.selling, CompanyStatus.notSelling, CompanyStatus.toReview].includes(this._userSellerService.user.companyStatus)) {
        this._messageService.showMessage(this._translateService.instant('INVOICE.SNACKBAR.ACTIVATED'));
      } else {
        this._invoiceService.checkPublish(uuid)
          .pipe(
            filter(invoice => this.checkCanPublish(invoice)),
            switchMap(_ => {
              return this._messageService.showModal(
                PublishTosDialogComponent,
                {
                  action: 'publish',
                  uuid: uuid,
                },
                false,
                true,
                650,
              );
            },
            ),
            tap(res => {
              if (res) {
                this._messageService.showMessage(this._translateService.instant('INVOICE.PUBLISH_DIALOG.SUCCESS'));
                this._invoiceService.refreshInvoice$.next();
              }
            }),
            catchError((err: FlamingoError) => {
              return this._messageService
                .showModal(
                  ErrorPublishDialogComponent,
                  {
                    error: err.errorObj.error,
                  },
                  false,
                  true,
                  600,
                );
            }),
          )
          .subscribe();
      }
    }
  }

  public checkUserProfile(): boolean {
    const user = this._mainService.user as SellerAccountView;

    if (!user.businessName) {
      return false;
    } else if (!user.taxCodePrefix) {
      return false;
    } else if (!user.taxCode) {
      return false;
    } else if (!user.IBAN) {
      return false;
    } else if (!user.certifiedEmail) {
      return false;
    } else if (!user.sdiNumber) {
      return false;
    } else if (!user.address1) {
      return false;
    } else if (!user.state) {
      return false;
    } else if (!user.city) {
      return false;
    } else if (!user.zip) {
      return false;
    } else if (!user.companyPhone) {
      return false;
    } else if (!user.legalRepresentativeFirstName) {
      return false;
    } else if (!user.legalRepresentativeLastName) {
      return false;
      // 2025/06/25 - hotfix: remove legalRepresentativeEmail check
      // } else if (!user.legalRepresentativeEmail) {
      //   return false;
    } else if (!user.legalRepresentativePhone) {
      return false;
    } else if (!user.birthDate) {
      return false;
    } else if (!user.IDNumber) {
      return false;
    } else if (!user.IDIssueDate) {
      return false;
    } else if (!user.IDIssuePlace) {
      return false;
    } else if (!user.firstName) {
      return false;
    } else if (!user.lastName) {
      return false;
    } else if (!user.phone) {
      return false;
    }
    /*     } else if (!user.legalRepresentativeBirthCity) {
          return false;
        } else if (!user.legalRepresentativeBirthState) {
          return false;
        } else if (!user.legalRepresentativeBirthCountry) {
          return false;
        } else if (!user.legalRepresentativeTaxCode) {
          return false;
        } else if (!user.legalRepresentativeAddress) {
          return false;
        } else if (!user.legalRepresentativeCity) {
          return false;
        } else if (!user.legalRepresentativeZip) {
          return false;
        } else if (!user.legalRepresentativeState) {
          return false;
        } else if (!user.legalRepresentativeCountry) {
          return false;
        } else if (!user.legalRepresentativeNationality) {
          return false;
        } */
    return true;
  }

  checkCanPublish(invoice: Invoice): boolean {
    if (moment(invoice.dueDate).diff(this.today, 'days') < 1) {
      this._messageService.showMessage(this._translateService.instant('INVOICE.SNACKBAR.DUE_DATE'));
      return false;
    }

    return true;
  }
}
